var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoMarkWhite = function SvgLogoMarkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.204 22v20.472l13.419-6.727V15.264L.203 22z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.797 20.59 23.677 0 6.914 8.419l20.12 20.59v20.48l16.764-8.418V20.59z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.323 47.735-6.7-1.754V35.745l6.7 1.745v10.245zM.204 22v20.472l13.419-6.727V15.264L.203 22z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43.797 20.59-16.764 8.418-20.12-20.59L23.678 0l20.12 20.59zM20.323 47.735l-6.7-1.754V35.745l6.7 1.745v10.245z",
    fill: "#fff"
  })));
};
export { SvgLogoMarkWhite as Component };
export default __webpack_public_path__ + "a9cdf25c3bdbfca46cd3629565fc6076.svg";